import { Catalogo, Catalogos } from "../../services/Catalogos";
import { ICatMetricaEcuve } from "../../services/Interfaces";


export class ICVUtils{

    CUBO_ECUVE : string = 'ecuve';
    CUBO_SISEVIVE : string = 'sisevive';
    
    
    
    ecM1 : String = '';
    ecM2 : String = '';
    siM1 : String = '';
    siM2 : String = '';
     
     public handleClickEventEcuve = (changeEvent:React.MouseEvent<HTMLInputElement>) => {
        //handleClickEvent( clickEvent );
        //console.log('handleRadioClick')
        
      const target = changeEvent.currentTarget;
      
      if(target.name==="R24_01" ){
		  if(target.checked)
		  	this.ecM1 = target.name;
		  else 
		  	this.ecM1 = "";
	  }
	  
	  if(target.name==="R24_02" ){
		  if(target.checked)
		  	this.ecM2 = target.name;
		  else 
		  	this.ecM2 = "";
	  }
	  
	  
      	  
    }
    
    

    /**
     * Retorna la cantidad de checks seleccionados en base al grupo 'tipo'
     * @param tipo 
     * @returns 
     */
    public numChecksSelecionados(tipo: string) : number  {
        let sels = 0;

        const chks = document.querySelectorAll<HTMLInputElement>( '.' + tipo ); 

        chks.forEach(value => {
            if( value.checked === true ) 
                sels++;                
        });

        return sels;
    }


    /**
     * Retorna la clase a mostrar dependiendo si se debe mostrar o no la sección de métricas.
     * Con al menos un indicador seleccionado se muestra. Si no hay nada seleccionado, se debe ocultar
     * @returns Retorna la clase para collapse.
     */
    public showMetricasClass () : string{

        

        if( this.numChecksSelecionados('queryDmns') > 0 )
            return 'collapse show';
        else
            return 'collapse hide';

    }


    /**
     * Inhabilita los checks del grupo especificado mediante 'tipo' si se ha llegado al maximo selecionado permitido.
     * En caso contrario, habilita todos los checks
     * @param tipo 
     * @param max 
     */
    habilitaChecks(tipo: string, max: number) {

        const chks = document.querySelectorAll<HTMLInputElement>( '.' + tipo ); 

        if( this.numChecksSelecionados(tipo) >= max ){
            chks.forEach(value => {
                if( value.checked === false )
                    value.disabled = true ;
            });            
        }
        
        else{
            chks.forEach(value => {
                value.disabled = false ;
            });
        }
    }



    /**
     * Habilita el check del mes si existe al menos un indicador seleccionado. 
     * En caso contrario lo inhabilita.
     */
    public habilitaMes() {

        const chkMes = document.querySelector<HTMLInputElement>( '.queryDmnsMes'); 
        
        if( this.numChecksSelecionados('queryDmns') > 0 )
            chkMes!=null ? chkMes.disabled = false : console.log('null');
        else
            chkMes!=null ? chkMes.disabled = true : console.log('null');
        
    }

    public showMetricas(tipoCubo : string) {
        
        //const leyenda : Element = <div className='col-12'><p className='bold negro'>Selecciona las métricas:</p></div>;
        
        if(tipoCubo == this.CUBO_ECUVE)
            return this.createMetricasECUVE();

        else if(tipoCubo == this.CUBO_SISEVIVE)
            return this.createMetricasSISEVIVE();
    }

    public createMetricasECUVE(){
		
		const leyenda = <div className='col-12'><p className='bold negro'>Selecciona las métricas:</p></div>;
		
		
        const element =(
			
            Catalogos.CAT_METRICAS_ECUVE.json.map( (item,i) =>{ return (
                <div key={ item.Id + i } className="custom-control custom-checkbox">
                    <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.TxRama }
                        className="custom-control-input queryMts"
                        //onClick={ this.handleClickEventEcuve }
                        />
                    <label className="custom-control-label" htmlFor={ item.Id } >{ item.TxRama }</label>
                </div> ) })
        );
        return  [leyenda, element];
        //return leyenda;
    }

    public createMetricasSISEVIVE(){
		
		const leyenda  = <div className='col-12'><p className='bold negro'>Selecciona las métricas:</p></div>;
		
        const element = (
            Catalogos.CAT_METRICAS_SISEVIVE.json.map( (item,i) =>{ return (
                <div key={ item.Id + i } className="custom-control custom-checkbox">
                    <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.TxRama }
                        className="custom-control-input queryMts"
                        //onClick={ handleClickEvent }
                        />
                    <label className="custom-control-label" htmlFor={ item.Id } >{ item.TxRama }</label>
                </div> ) })
        );
        //return element;
        return  [leyenda, element];
    }
    
    
    
    public getDimensionesSeleccionadas(){
		
		let dims : string[] = [];
		
		
		const chks = document.querySelectorAll<HTMLInputElement>( '.queryDmns' ); 

        chks.forEach(obj => {
            if(obj.checked === true )            	
				dims.push(obj.value);              			
        });
        
        return dims;
	}
    
    
    public getMetricasSeleccionadas(){
		
		let mts : string[] = [];
		
		
		const chks = document.querySelectorAll<HTMLInputElement>( '.queryMts' ); 

        chks.forEach(obj => {
			//Para el Caso de ECUVE y SISEVIVE se deben mandar ambas métricas aunque uno no esté seleccionada para así poder sacar el promedio
            if(obj.checked === true )              	
				mts.push(obj.name);              			
        });

        return mts;
	}

 
 	public validaForm(elementos:any, validCal:boolean) : string{
		 
		 console.log("Valida Form");
		 
		 //let dims : string[] = this.getDimensionesSeleccionadas();
		 
		 if(this.getDimensionesSeleccionadas().length === 0)
			 return "Debe seleccionar al menos una variable";
		 
		 
		 //console.log(dims.length);
		 
		 
		 if(validCal===false)
		 	return "Debe capturar un periodo correcto";
		 
		 
		 /*
		 try{
			 let res = parseInt(elementos.periodo_anio_inicio) + parseInt(elementos.periodo_anio_fin) + parseInt(elementos.periodo_mes_inicio) + 
			 			parseInt(elementos.periodo_mes_fin);
			 console.log(res);
			 if(isNaN(res)){
				 console.log("NAN");
			 	return "Debe capturar un periodo correcto"
			 }
			 
			 
		 }catch(e:any){
			 console.log("Exception " + e);
			 return "Debe capturar un periodo correcto"
		 }
		 */
		 
		 console.log(elementos);
		 
		 /*
		 if(elementos.periodo_anio_inicio === "" ||  elementos.periodo_mes_inicio === ""){
			 return "Debe capturar un periodo de inicio correcto"
		 }
		 
		 
		 if(elementos.periodo_anio_fin === "" ||  elementos.periodo_mes_fin === ""){
			 return "Debe capturar un periodo de fin correcto"
		 }
		 
		 if(elementos.periodo_anio_inicio >   elementos.periodo_anio_fin ){
			 return "La fecha de inicio no puede ser mayor a la de fin 1"
		 }
		 
		 
		 if(elementos.periodo_anio_inicio ===  elementos.periodo_anio_fin   &&  (elementos.periodo_mes_inicio > elementos.periodo_mes_fin)  ){
			 return "La fecha de inicio no puede ser mayor a la de fin 2"
		 }
		 */
		 
		 
		 
		 //let mts : string[] = this.getMetricasSeleccionadas();
		 
		 //console.log(mts.length);
		 
		 if(this.getMetricasSeleccionadas().length == 0){
			 return "Debe seleccionar al menos una metrica";
		 }
		 
		 return '';
	 }   
	 
	 


	 public resetICV(){
		 
		 const dims = document.querySelectorAll<HTMLInputElement>( '.queryDmns' );
		 //const mts  = document.querySelectorAll<HTMLInputElement>( '.queryMts' );
		 
		//console.log("obj...");  
		//console.log(dims);
        dims.forEach(obj => {
			//console.log(obj);
			obj.checked = true;
			obj.disabled = false;              			
        });
        
        
        const chkMes = document.querySelectorAll<HTMLInputElement>( '.queryDmnsMes' );
		chkMes.forEach(obj => {			
			obj.disabled = true;              			
        });
        
	 }
	 
	 

}